"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseOrigin = exports.ContractStatus = exports.LicenseType = exports.LicenseCategory = void 0;
var LicenseCategory;
(function (LicenseCategory) {
    LicenseCategory["MOD"] = "MOD";
    LicenseCategory["FOD"] = "FOD";
})(LicenseCategory || (exports.LicenseCategory = LicenseCategory = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["LIFETIME"] = "LIFETIME";
    LicenseType["ACTIVE"] = "ACTIVE";
    LicenseType["INACTIVE"] = "INACTIVE";
    LicenseType["ENDING_SOON"] = "ENDING_SOON";
    LicenseType["EXPIRED"] = "EXPIRED";
})(LicenseType || (exports.LicenseType = LicenseType = {}));
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["PENDING"] = "PENDING";
    ContractStatus["ACTIVE"] = "ACTIVE";
    ContractStatus["EXPIRING"] = "EXPIRING";
    ContractStatus["TERMINATED"] = "TERMINATED";
    ContractStatus["REVOKED"] = "REVOKED";
})(ContractStatus || (exports.ContractStatus = ContractStatus = {}));
var LicenseOrigin;
(function (LicenseOrigin) {
    LicenseOrigin["CAR_NET_SHOP"] = "CAR_NET_SHOP";
    LicenseOrigin["VDBS"] = "VDBS";
})(LicenseOrigin || (exports.LicenseOrigin = LicenseOrigin = {}));
//# sourceMappingURL=types.js.map